import WidgetContainer from "../../UiLib/WidgetContainer/WidgetContainer";
import "./Modal.css";
import Button from "../../UiLib/Button/Button";
import Cross from "../../../assets/images/cross.svg";
import Checkmark from "../../../assets/checkmarkGreen.svg";
import { FC } from "react";

interface IModalSuccessProps {
    onClose?: () => void;
    bodyText?: string;
    headerText?: string;
    hideCross?: boolean;
    hideOk?: boolean;
}

const ModalSuccess: FC<IModalSuccessProps> = ({
    onClose,
    bodyText,
    headerText,
    hideCross,
    hideOk,
}) => {
    return (
        <WidgetContainer
            className="modal-container"
            style={{ 
                minHeight: "10px", 
                minWidth: "10px",
                height: "100%", 
                display: "flex", 
                flexDirection: "column", 
                justifyContent: "space-between",
                width: "350px"
            }}
        >
            <div className="modal-header">
                <h1>
                    <img src={Checkmark}></img>
                </h1>
                {!hideCross ? (
                    <Button
                        callBack={() => (onClose ? onClose() : null)}
                        image={Cross}
                    />
                ) : null}
            </div>
            <div style={{flex: "1 1"}}>
                <div className="modal-header-text">{headerText}</div>
                <div className="modal-body-text">{bodyText}</div>
            </div>
            <div className="modal-buttons">
                {!hideOk ? (
                    <button
                        className="light-blue-button-blue-text"
                        onClick={onClose}
                    >
                        Ок
                    </button>
                ) : null}
            </div>
        </WidgetContainer>
    );
};

export default ModalSuccess;
